import { auth, db } from "./firebaseAuth";
import { onValue, ref, set, push, serverTimestamp, update } from "firebase/database";
import { signInAnonymously } from "firebase/auth";
import store from "@/store";

const activeListeners = new Map();
const defaultSystem = store?.state?.defaultSystem;
const customer = defaultSystem?.customer;
const customer_id = customer?.id;

async function firebaseListener(topic, funcSnapshot) {
    await signInAnonymously(auth);
    const env = process.env.VUE_APP_FIREBASE_ENV_TOPIC;
    const baseTopic = topic || 'default';
    const fullPath = `${env}/${baseTopic}`;
    // ========== ========== ========== ==========
    if (activeListeners.has(fullPath)) {
        console.log(`Listener for [${fullPath}] is already active.`);
        return;
    }
    const statusRef = ref(db, fullPath);
    // onValue จะคืนค่าฟังก์ชันสำหรับ Unsubscribe ออกมา
    const unsubscribe = onValue(
        statusRef,
        (snapshot) => {
            const data = snapshot.val();
            if (data && funcSnapshot && typeof funcSnapshot == 'function') {
                const ack = `employee_id_${customer_id}_ack`;
                if (customer_id && !data[`${ack}`]) {
                    funcSnapshot(data)
                    firebaseSendMessage(topic, 'update', {
                        [`${ack}`]: true,
                    })
                }
            }
        },
        (error) => {
            console.error("RTDB Read Error:", error);
        }
    );
    // ========== ========== ========== ==========
    activeListeners.set(fullPath, unsubscribe);
}

function firebaseStopListener(topic) {
    const env = process.env.VUE_APP_FIREBASE_ENV_TOPIC;
    const baseTopic = topic || 'default';
    const fullPath = `${env}/${baseTopic}`;
    // ========== ========== ========== ==========
    if (activeListeners.has(fullPath)) {
        const unsubscribe = activeListeners.get(fullPath);
        unsubscribe();
        activeListeners.delete(fullPath);
        console.log(`Stopped listener for [${fullPath}]`);
    }
}

async function firebaseSendMessage(topic, type = 'set', message) {
    try {
        const env = process.env.VUE_APP_FIREBASE_ENV_TOPIC;
        const baseTopic = topic || 'default';
        const fullPath = `${env}/${baseTopic}`;
        const topicRef = ref(db, fullPath);
        const newData = {
            ...message,
            timestamp: serverTimestamp(),
        };
        if (type == 'set') {
            await set(topicRef, newData);
        } else if (type == 'push') {
            await push(topicRef, newData);
        } else if (type == 'update') {
            await update(topicRef, newData);
        }
    } catch (err) {
        console.log("firebaseSendMessage", err)
    }
}

export {
    firebaseListener,
    firebaseStopListener,
    firebaseSendMessage,
}